// const BASE_URL = 'http://localhost:8080';
const BASE_URL = 'https://final-project-quiz-gl4puda6xq-lz.a.run.app';

// slug is the suffix of the request
export const API_URL = (slug) => `${BASE_URL}/${slug}`;
